export const isUrlEndsWithSupport = () =>
  window.location.href.endsWith('support')
